/* eslint-disable camelcase, class-methods-use-this */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual, get } from 'lodash';
import { Table } from 'react-bootstrap';
import CircularProgressbar from 'react-circular-progressbar';
import RichTextDisplay from '../../components/RichTextDisplay';
import { SECTION_ITEM_TYPES } from '../../Constants';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import VerbText from '../../components/VerbText';
import WorkspaceSlideHeader from './WorkspaceSlideHeader';

export class QuizResultSlide extends Component {
    static propTypes = {
        completedData: PropTypes.object,
        sectionItems: PropTypes.array,
        onChange: PropTypes.func,
        name: PropTypes.string.isRequired,
        canMoveToNext: PropTypes.func,
        abQuestionContent: PropTypes.object,
        currentUser: PropTypes.object,
        content: PropTypes.shape({ description: PropTypes.string }),
        sectionId: PropTypes.string,
        sectionItemId: PropTypes.string,
        hideBookmark: PropTypes.bool,
        sendWorkspaceSegementEvent: PropTypes.func,
        isRefSheet: PropTypes.bool,
    };

    componentDidMount() {
        const { completedData, onChange, canMoveToNext } = this.props;
        const isCompleted = true;
        console.log('ok 1');
        const isAnswered = true;
        onChange(get(completedData, 'data', null), isCompleted, isAnswered);
        canMoveToNext(true);
        console.log('ok 2');
    }

    componentDidCatch(error, info) {
        console.log(error, info);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.abQuestionContent, this.props.abQuestionContent)) {
            this.props.canMoveToNext(true);
        }
    }

    _getTotalQuizCountObject = () => {
        const { completedData, sectionItems } = this.props;
        const quizCountObject = {
            correct: 0,
            totalItemsCount: 0,
            quizItems: []
        };

        sectionItems.forEach((item) => {
            if (item.type.toLocaleUpperCase() === SECTION_ITEM_TYPES.CHOOSE_ONE_QUIZ) {
                quizCountObject.totalItemsCount += 1;
                if (get(completedData, `${item.id}.data.isCorrect`, false)) {
                    quizCountObject.correct += 1;
                    quizCountObject.quizItems.push([item, get(completedData, `${item.id}.data`, '')]);
                } else {
                    quizCountObject.quizItems.push([item, get(completedData, `${item.id}.data`, '')]);
                }
            }
        });

        return quizCountObject;
    };

    _getTableItem = (data) => {
        const quizData = data[0];
        const answerData = data[1];
        let answers = get(quizData, 'content.options', []);
        answers = answers.reduce((acc, answer) => {
            acc[answer.id] = answer;
            if (answer.isCorrect) {
                acc.correct = answer;
            }
            return acc;
        }, {});

        const correctSymbol = <i className={'fas fa-check'} aria-hidden={'true'} />;
        const wrongSymbol = <i className={'fas fa-times'} aria-hidden={'true'} />;
        return (
            <tr key={quizData.name}>
                <td>{quizData.name}</td>
                <td>
                    <RichTextDisplay
                        className={'verbRadioOption-label'}
                        htmlToDisplay={get(answers, `${answerData.id}.label`, '')}
                        currentUser={this.props.currentUser}
                        sendSegementEvent={this.props.sendWorkspaceSegementEvent}
                    />
                </td>
                <td>
                    <RichTextDisplay
                        className={'verbRadioOption-label'}
                        htmlToDisplay={answers.correct.label}
                        currentUser={this.props.currentUser}
                        sendSegementEvent={this.props.sendWorkspaceSegementEvent}
                    />
                </td>
                <td>{answers.correct.id === answerData.id ? correctSymbol : wrongSymbol}</td>
            </tr>
        );
    };

    render() {
        const {
            name,
            content: { description },
            sectionId,
            sectionItemId,
            currentUser,
            hideBookmark,
            sendWorkspaceSegementEvent,
            isRefSheet = false,
        } = this.props;
        const totalQuizCountObject = this._getTotalQuizCountObject();
        const percent = Math.floor((totalQuizCountObject.correct / totalQuizCountObject.totalItemsCount) * 100);
        const percentText = `${percent}%`;
        let answers = [];
        if (totalQuizCountObject.quizItems.length) {
            answers = totalQuizCountObject.quizItems.map((data) => this._getTableItem(data));
        }

        return (
            <div className={'quizResultSlide'}>
                <div className={'playerContent'}>
                    <WorkspaceSlideHeader
                        headerText={name}
                        currentSectionItemId={sectionItemId}
                        currentSectionId={sectionId}
                        currentUser={currentUser}
                        hideBookmark={hideBookmark}
                        isRefSheet={isRefSheet}
                    />
                    <div className={'col-12 col-md-12 quizResultHeading'}>
                        <div className={'col-md-3'}>
                            <CircularProgressbar
                                initialAnimation={true}
                                textForPercentage={() => percentText}
                                percentage={percent}
                            />
                        </div>
                        <div className={'col-md-10 resultDescription'}>
                            <RichTextDisplay
                                className={'playerDescription'}
                                htmlToDisplay={description}
                                sendSegementEvent={sendWorkspaceSegementEvent}
                            />
                        </div>
                    </div>
                    <div className={'col-md-12'}>
                        <Table striped={false} bordered={false} hover={false} className={'quizResultTable'}>
                            <thead>
                                <tr>
                                    <th>
                                        <VerbText
                                            messageId={'WORKSPACE_QUIZ_QUESTION_HEADER'}
                                            defaultMessage={'Question'}
                                        />
                                    </th>
                                    <th>
                                        <VerbText
                                            messageId={'WORKSPACE_QUIZ_ANSWER_HEADER'}
                                            defaultMessage={'Your Answer'}
                                        />
                                    </th>
                                    <th>
                                        <VerbText
                                            messageId={'WORKSPACE_QUIZ_CORRECT_HEADER'}
                                            defaultMessage={'Correct Answer'}
                                        />
                                    </th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>{answers}</tbody>
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}

export default TrackPlayerSlideComponent(QuizResultSlide);
